import type { RulesetConfig } from "../types/yup";

export const passwordConfig: RulesetConfig = {
  validationRegex:
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,}$/,
  required: true,
  message: {
    validationRegex:
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character",
    required: "Password is required",
  },
};

export const emailConfig: RulesetConfig = {
  required: true,
  email: true,
  message: {
    required: "Email is required",
    email: "Please provide a valid email address",
  },
};

export const fullNameConfig: RulesetConfig = {
  required: true,
  validationRegex: /^[a-zA-Z\s]*$/,
  min: 3,
  max: 50,
  message: {
    required: "Full name is required",
    min: "Full name must be at least 3 characters",
    max: "Full name must be less than 50 characters",
    validationRegex: "Full name must contain only letters and spaces",
  },
};

export const firstNameConfig: RulesetConfig = {
  required: true,
  validationRegex: /^[a-zA-Z\s]*$/,
  min: 3,
  max: 50,
  message: {
    required: "First name is required",
    min: "First name must be at least 2 characters",
    max: "First name must be less than 50 characters",
    validationRegex: "First name must contain only letters and spaces",
  },
};

export const lastNameConfig: RulesetConfig = {
  required: true,
  validationRegex: /^[a-zA-Z\s]*$/,
  min: 3,
  max: 50,
  message: {
    required: "Last name is required",
    min: "Last name must be at least 3 characters",
    max: "Last name must be less than 50 characters",
    validationRegex: "Last name must contain only letters and spaces",
  },
};

export const schoolNameConfig: RulesetConfig = {
  required: true,
  validationRegex: /^[a-zA-Z\s]*$/,
  min: 3,
  max: 50,
  message: {
    required: "School name is required",
    min: "School name must be at least 3 characters",
    max: "School name must be less than 50 characters",
    validationRegex: "School name must contain only letters and spaces",
  },
};
